/*
 * NOTE: @container query thresholds — authoring convention
 *
 * These constants are consumed via styled-components template literal interpolation:
 *   @container (width <= ${CARD_WIDTH})
 *
 * Styled-components resolves the interpolation at render time, so the browser receives
 * a literal pixel value — never a CSS custom property. Do NOT use var(--*) strings
 * (from src/styles/tokens/) as container query thresholds; browsers reject them.
 * Prop-driven thresholds (e.g. $minItemWidth) follow the same rule: the prop value
 * must be a literal pixel string, not a CSS var reference.
 *
 * If a threshold is derived from token math, compute it here as a numeric constant
 * (e.g. const CARD_STACK_THRESHOLD_PX = 3 * 24) and interpolate: `${CARD_STACK_THRESHOLD_PX}px`.
 */

export const LIST_ITEM_HEIGHT = '54px';
export const LIST_ITEM_HEIGHT_WITH_BORDER = '53px';
export const BUILDER_BASE_WIDTH = '800px';
export const CARD_WIDTH = '315px';
export const MIN_PANEL_WIDTH = 130;
export const PREVIEW_IMAGE_HEIGHT = '196px';
export const GLOBAL_NAV_WIDTH = '60px';
export const BUILDER_STEP_LEGEND_WIDTH = '40%';
export const BUILDER_FIELDS_CONTAINER_BASE_WIDTH = '60%';
export const MIN_GRID_SECTION_WIDTH = '172px';
/*
 * Gap between grid items — literal mirror of --space-600 (24px).
 * Consumed in @container query math (HeroSection STACKED_VIEW_BREAKPOINT, ItemGrid, ResponsiveGrid),
 * which rejects var(--*) strings. See NOTE at top of file.
 */
export const GRID_ITEM_GAP = '24px';
/*
 * Gap between cards in responsive card grids — literal mirror of --space-400 (16px).
 * Consumed in @container query math via ResponsiveGrid $gap prop.
 */
export const CARD_GRID_GAP = '16px';
export const SETTINGS_DETAIL_SIDE_SHEET_WIDTH = '85vw';
export const SETTINGS_DETAIL_SIDE_SHEET_MAX_WIDTH = 'min(85vw, 600px)';

export const BREAKPOINTS = {
  EXTRA_LARGE: '1500px',
  LARGE: '1024px',
};
